import { useEffect, useRef } from 'react';

/**
 * Ferme un panneau (dropdown, menu) au clic extérieur ou Escape.
 * @returns ref à placer sur le conteneur englobant trigger + contenu.
 */
export function useDismissOnOutsideClick(isOpen, onClose, options = {}) {
  const { escape = true } = options;
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleMouseDown = (event) => {
      const el = ref.current;
      if (el && !el.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = (event) => {
      if (escape && event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose, escape]);

  return ref;
}
